<template lang="pug">
	.project-version-preview-create(v-if="showed && Version.SelectedVersion")
		.card
			.card-header
				i.fa.fa-edit
				span Create New Project Version Preview
			.card-body.collapse.show
				.form-horizontal(v-if="state === 'create'")
					.form-group
						label.col-form-label Show logo
						.controls
							label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
								input.switch-input.form-check-input(type="checkbox" v-model="showLogo")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
					.form-group
						label.col-form-label Allow rotation and device change
						.controls
							label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
								input.switch-input.form-check-input(type="checkbox" v-model="allowRotation" :disabled="Project.SelectedProject.type === 'banner'")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
					.form-group
						label.col-form-label Default device proportions
						.controls
							select.custom-select.custom-select-sm(v-model="defaultDevice" :disabled="Project.SelectedProject.type === 'banner'")
								option(:selected="defaultDevice === 'iPhoneX'" :value="'iPhoneX'") 19.5:9 (iPhoneX)
								option(:selected="defaultDevice === 'iPhone'" :value="'iPhone'") 16:9 (iPhone)
								option(:selected="defaultDevice === 'iPad'" :value="'iPad'") 4:3 (iPad)
								option(:selected="defaultDevice === 'square'" :value="'square'") 1:1 (square)
					.form-group
						label.col-form-label Default orientation
						.controls
							select.custom-select.custom-select-sm(v-model="defaultOrientation" :disabled="Project.SelectedProject.type === 'banner'")
								option(:selected="defaultOrientation === 'portrait'" :value="'portrait'") Portrait
								option(:selected="defaultOrientation === 'landscape'" :value="'landscape'") Landscape
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="createPreview()") Create new preview
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
				.form-center(v-if="state === 'waiting'")
					.form-group
						.text.icon.fa.fa-spinner.fa-spin
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Project } 			from './../../services/Project';
	import { Version } 			from './../../services/Version';
	import { Settings } 		from './../../services/Settings';

	import _ 					from 'lodash';
	import changeCase 			from "change-case";

	export default {
		name: "ProjectVersionPreviewCreate",
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		data() {

			this.Project = Project;
			this.Version = Version;
			this.Settings = Settings;

			return {
				allowRotation: true,
				showLogo: true,
				defaultDevice: 'iPhone',
				defaultOrientation: 'portrait',
				state: 'create'
			};

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion) return;

				this.title = this.getNextSettingsTitle();

				if (Project.SelectedProject && Project.SelectedProject.type === 'banner') this.allowRotation = false;

			},
			createPreview() {

				Server.sendToSocket({
					CreatePreview: {
						versionId: Version.SelectedVersion.id,
						allowRotation: this.allowRotation,
						defaultDevice: this.defaultDevice,
						defaultOrientation: this.defaultOrientation,
						showLogo: this.showLogo
					}
				});

				Broadcast.call("New Preview Creating");

				this.state = 'waiting';

				Broadcast.once("New Preview Created", () => {

					Broadcast.call("Show ProjectVersionPreviewList");

					this.hide();

					this.state = 'create';

					this.$nextTick(() => {

						Broadcast.call("New Preview Creating Completed"); // Нужно для обучения

					});

				});

			},
			getNextSettingsTitle() {

				let title_base = changeCase.titleCase(Version.SelectedVersion.codename || Version.SelectedVersion.title || Project.SelectedProject.codename) + ' ';

				let title_number = 2;
				let title = title_base + title_number;

				while (_.find(Version.VersionsByProject, version => {return version.title === title})) {

					title_number++;
					title = title_base + title_number;

				}

				return title;

			}
		}
	}
</script>


<style lang="sass">

	.project-version-preview-create
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.custom-select
			cursor: pointer
			color: #fff
			width: auto
			background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
			background-color: #343b41
			border: 1px solid #23282c
			margin-top: 0
			float: none !important

			&.selected
				background-color: #4dbd74

		.card
			width: 400px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 320px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark
				float: right
				color: #fff

			.existing-previews
				background-color: #343b41
				border-bottom: 1px solid #23282c
				padding: 1.25rem

			.form-horizontal
				display: flex
				flex-direction: column

				.form-group
					display: flex
					flex-direction: row
					justify-content: space-between
					align-items: center
					margin-bottom: 0.5rem

				.form-actions
					margin-top: 1.5rem

			.form-center
				display: flex
				height: 100%
				justify-content: center
				align-items: center
				font-size: 2rem

		.switch-slider
			background-color: #343b41
			border: 1px solid #23282c

</style>

